import { render, staticRenderFns } from "./PriorityTypeUpdate.vue?vue&type=template&id=1f08cb9e&"
import script from "./PriorityTypeUpdate.vue?vue&type=script&lang=js&"
export * from "./PriorityTypeUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports